import {Feature} from 'acng/core/model/feature.js';

const name = 'alternativeProducts';
export default name;
export const alternativeProductsFeature = new Feature(name);
